// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"231":"component---node-modules-shapeable-gatsby-theme-shapeable-src-components-app-tsx","715":"component---node-modules-shapeable-gatsby-theme-shapeable-src-pages-404-tsx"}[chunkId] + "-" + {"231":"4f1216e6fe899345089f","715":"abebccda822f6fe17eeb"}[chunkId] + ".js";
};